import React, { useEffect, useState } from "react";
import { Input, Spinner } from "reactstrap";
import { listSchemaOptimizerJobHistory } from "../../../services/schemaOptimizerApi";
import { jobTimestamp } from "./schemaOptimizerUtils";

function formatHistoryOption(job) {
	const ts = jobTimestamp(job);
	const id = job.id ?? job.job_id;
	if (!ts) return `Job #${id}`;
	return ts.toLocaleString(undefined, {
		day: "2-digit",
		month: "short",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
	});
}

export default function SchemaOptimizerHistorySelect({
	websiteId,
	url,
	currentJobId,
	onSelectJobId,
	disabled,
}) {
	const [jobs, setJobs] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!websiteId || !url) {
			setJobs([]);
			return;
		}
		let cancelled = false;
		(async () => {
			setLoading(true);
			const res = await listSchemaOptimizerJobHistory(websiteId, url, {
				skip: 0,
				limit: 30,
			});
			if (cancelled) return;
			setLoading(false);
			if (res.ok) setJobs(res.jobs || []);
			else setJobs([]);
		})();
		return () => {
			cancelled = true;
		};
	}, [websiteId, url]);

	if (loading && jobs.length === 0) {
		return <Spinner size="sm" />;
	}

	if (jobs.length <= 1) {
		const ts = jobs[0] ? formatHistoryOption(jobs[0]) : "Current run";
		return (
			<span className="schema-optimizer__history-static small text-muted">{ts}</span>
		);
	}

	return (
		<Input
			type="select"
			bsSize="sm"
			className="schema-optimizer__history-select"
			value={String(currentJobId ?? "")}
			disabled={disabled || loading}
			onChange={(e) => {
				const next = e.target.value;
				if (next && String(next) !== String(currentJobId)) {
					onSelectJobId(next);
				}
			}}
		>
			{jobs.map((job) => {
				const id = job.id ?? job.job_id;
				return (
					<option key={id} value={String(id)}>
						{formatHistoryOption(job)}
					</option>
				);
			})}
		</Input>
	);
}
